eshopApp.controller('CategoriesNavSingleLevelController', ['$scope', function($scope) {
    $scope.selectedCategoryId = null;
    // Set selected category ID. Used to dynamically switch category in CategoryProducts Module (CategoryProductsDynamic)
    $scope.setSelectedCategory = function(event, category_id, category_level) {
        if (category_level > 1) {
            event.preventDefault();
            $scope.selectedCategoryId = category_id;
        }
    };

}]);
